import { createContext, useState } from 'react'

interface BulkActionContextValue {
    isLoading: boolean
    setLoading: (boolean) => void
}

export const BulkActionContext = createContext<BulkActionContextValue>(
    {} as BulkActionContextValue
)

export const BulkActionContextProvider = ({ children }) => {
    const [isLoading, setIsLoading] = useState(false)

    const contextValue = {
        isLoading,
        setLoading: setIsLoading,
    }
    return (
        <BulkActionContext.Provider value={contextValue}>
            {children}
        </BulkActionContext.Provider>
    )
}
